module.exports = __webpack_public_path__ + "img/parking-garage-thumb.5203e451.jpg";